export default "__VITE_ASSET__DuRaeIXP__"